import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/home/deployuser/infinitcode-ai/prod/infinitcode-ai-website/src/components/about/hero-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MissionSection"] */ "/home/deployuser/infinitcode-ai/prod/infinitcode-ai-website/src/components/about/mission-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamSection"] */ "/home/deployuser/infinitcode-ai/prod/infinitcode-ai-website/src/components/about/team-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/deployuser/infinitcode-ai/prod/infinitcode-ai-website/src/components/Footer.tsx");
